import * as d3 from "d3";

import { DeploymentService } from "Api/organizations/projects/environments/deployments/types";
import { AreaProps } from "src/organization/pages/project/environment/metrics/http/types";

import { ResourceType } from "../types";

export type ServiceMetricsType = DeploymentService & {
  metrics: ResourceUnitMetrics;
  kind: "webapp" | "worker" | "service";
  metricsMap?: Record<string, Map<string, MiniMetrics>>;
};

export type AllocationAreaProps = AreaProps<any> & {
  bands: Record<string, string>;
};

export type TotalSeriesType = d3.Series<
  {
    [key: string]: number;
  },
  string
>[];

export type SeriesDataType = Record<string, number & { date: Date }>;

export type MiniMetrics = {
  date: Date;
  max: number;
  "average@value": number;
};

export type ResourcesServiceMetricsType = {
  points?: Array<[string, ResourceType]>;
  services: Array<
    DeploymentService & {
      kind: "webapp" | "worker" | "service";
      metrics: Record<string, Array<Record<string, number>>>;
      id: string;
    }
  >;
};

export const resouceUnit = ["/tmp", "cpu", "memory", "/mnt"] as const;
export type MetricsUnit = (typeof resouceUnit)[number];
export type ResourceUnitMetrics = Record<MetricsUnit, Array<MiniMetrics>>;

export type MetricsUnit2 = Array<{
  sum: { value: number; max: number };
  data: Array<unknown>;
  date: Date;
}>;
